
export const getTilesData = (data) => {
    let preselectedImage = data?.images[0]; //TODO - check if this image will always exist
    preselectedImage = Array.isArray(data?.images) && data?.images.find(element => element.preselected);
    const pageTitle = data?.title || '';
    const tilesList = data?.category || [];
    const userData = data?.user || {};
    return {preselectedImage, pageTitle, tilesList, userData};
}